import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

const { cyan, grey, mono, grey: { mischka: { russian }, regent } } = COLOURS;

const borderColor = ({ checked, darkMode, disabled }) => {
  if (checked) {
    return disabled ? regent : cyan.jungleGreen.monkey;
  }

  return darkMode ? mono.white : russian;
};

const backgroundColor = ({ checked, darkMode, disabled }) => {
  if (checked) {
    return disabled ? russian : cyan.jungleGreen.monkey;
  }

  if (darkMode) return mono.white25;

  return disabled ? russian : grey.athens.parthenon;
};

export const CHECKBOX_CONTAINER = ({
  disabled,
  checked,
  darkMode




}) => cxs({
  alignItems: 'center',
  cursor: disabled ? 'default' : 'pointer',
  display: 'flex',
  ':hover':
  !checked && !disabled ?
  {
    ' > .check-box__box': {
      borderColor: darkMode ? void 0 : grey.regent,
      borderWidth: darkMode ? '2px' : void 0
    }
  } :
  {}
});

export const CHECKBOX = ({
  checked,
  darkMode,
  disabled




}) => cxs({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: backgroundColor({ checked, darkMode, disabled }),
  border: `1px solid ${borderColor({ checked, darkMode, disabled })}`,
  borderRadius: '4px',
  boxSizing: 'border-box',
  width: '20px',
  minWidth: '20px',
  height: '20px',
  minHeight: '20px'
});

export const CHECKBOX_CONTENT = ({ darkMode }) => cxs({
  marginLeft: '20px',
  color: darkMode ? mono.white : void 0,
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',

  ' > .icon-container': {
    marginRight: '20px'
  }
});